import { inject } from '@angular/core';
import { CanActivateFn, NavigationExtras, Router } from '@angular/router';
import {
  AbilityAction,
  AbilitySubject,
} from '@kinet-open-network/shared/data-access/model';
import { map } from 'rxjs';
import { AbilityService } from '../services/ability.service';

export interface CanGuardOptions {
  returnTo?: any[] | any;
  returnToExtras?: NavigationExtras;
}

export const canGuard = (
  action: AbilityAction,
  subject: AbilitySubject,
  options?: CanGuardOptions,
): CanActivateFn => {
  return (route, state) => {
    const abilityService = inject(AbilityService);
    const router = inject(Router);

    return abilityService.ability$.pipe(
      map((ability) => ability.can(action, subject)),
      map((can) => {
        if (!can) {
          console.log('user cannot', action, subject);

          return router.createUrlTree(
            options?.returnTo || ['/forbidden'],
            options?.returnToExtras,
          );
        }

        return true;
      }),
    );
  };
};
